//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import constant from '~/const';
import extraConfig from './extraConfig';

export default {
  props: {
    stats: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      extraConfig,
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
  },
};

